import React from 'react';
import { BrokerGroupTextField } from '@/admin/brokerGroups/BrokerGroupDrawer/BrokerGroupTextField';
import { Grid, Typography } from '@mui/material';
import { AdminReadOnlyField } from '@/admin/shared/AdminReadOnlyField';
import { BrokerGroupAdminConsentField } from '@/admin/brokerGroups/BrokerGroupDrawer/BrokerGroupAdminConsentField';

export const SharepointFields = ({ sharepointSiteId, clientFolderDriveId, tenant }) => {
	return (
		<>
			<Grid size={12}>
				<Typography variant='form_label'>Sharepoint information</Typography>
			</Grid>
			<BrokerGroupTextField name='sharepointDomain' sm={4} />
			<BrokerGroupTextField
				name='clientSiteSuffix'
				helperText='Leave empty for the root site'
				sm={4}
			/>
			<BrokerGroupTextField name='clientFolder' sm={4} />
			<AdminReadOnlyField label='SharePoint site id' value={sharepointSiteId} sm={4} />
			<AdminReadOnlyField
				label='Client folder drive id'
				value={clientFolderDriveId}
				sm={4}
			/>
			<BrokerGroupAdminConsentField hasTenant={Boolean(tenant)} />
		</>
	);
};
